/**
 * La misma foto, mas pequeña. Las de la tienda viven en el almacen de imagenes de
 * Shopify, que las sirve al ancho que se le pida; pedirlas a su tamaño original
 * serian varios megas por listado.
 *
 * Aparte de `datos.ts` porque tambien la usan las pantallas del navegador (la
 * cesta), que no pueden arrastrar nada de servidor.
 */
export function conAncho(url: string, ancho: number): string {
  try {
    const direccion = new URL(url)
    if (!direccion.hostname.endsWith("shopify.com")) return url
    direccion.searchParams.set("width", String(ancho))
    return direccion.toString()
  } catch {
    return url
  }
}
